import { render } from "./index.vue?vue&type=template&id=1b3c7faa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1b3c7faa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3c7faa"],['__file',"src/vab/components/VabIcon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b3c7faa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b3c7faa', __exports__)) {
    api.reload('1b3c7faa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1b3c7faa&scoped=true", () => {
    api.rerender('1b3c7faa', render)
  })

}


export default __exports__